import Api from "../api";
const { axios: api } = Api;

const PREFIX = "image";

export const getImageById = async (imageId) => {
  const data = await api.get(`/${PREFIX}/${imageId}`);
  return { data: data.data };
};
